import { z } from 'zod';

import {
  ValueFormat,
  LineBarGraphViz,
  BarChartViz,
  LineChartViz,
  KpiCardViz,
  PieDonutViz,
  TableViz,
  NoDataViz
} from './ai-viz-types';

// ─── Labeled Table Column ───

export const LabeledTableColumnDef = z.object({
  key: z.string().min(1),
  label: z.string().min(1),
  format: ValueFormat
});
export type LabeledTableColumnDef = z.infer<typeof LabeledTableColumnDef>;

// ─── Labeled Viz Variants ───

export const LabeledLineBarGraphViz = LineBarGraphViz.extend({
  labels: z.object({
    timeLabel: z.string().min(1),
    plannedLabel: z.string().min(1),
    barLabels: z.record(z.string(), z.string()),
    axisFormat: ValueFormat
  })
});
export type LabeledLineBarGraphViz = z.infer<typeof LabeledLineBarGraphViz>;

export const LabeledBarChartViz = BarChartViz.extend({
  labels: z.object({
    categoryLabel: z.string().min(1),
    valueLabels: z.record(z.string(), z.string()),
    axisFormat: ValueFormat
  })
});
export type LabeledBarChartViz = z.infer<typeof LabeledBarChartViz>;

export const LabeledLineChartViz = LineChartViz.extend({
  labels: z.object({
    timeLabel: z.string().min(1),
    lineLabels: z.record(z.string(), z.string()),
    axisFormat: ValueFormat
  })
});
export type LabeledLineChartViz = z.infer<typeof LabeledLineChartViz>;

export const LabeledKpiCardViz = KpiCardViz.extend({
  labels: z.object({
    valueLabel: z.string().min(1),
    valueFormat: ValueFormat,
    deltaFormat: ValueFormat.optional()
  })
});
export type LabeledKpiCardViz = z.infer<typeof LabeledKpiCardViz>;

export const LabeledPieDonutViz = PieDonutViz.extend({
  labels: z.object({
    categoryLabel: z.string().min(1),
    valueLabel: z.string().min(1),
    valueFormat: ValueFormat
  })
});
export type LabeledPieDonutViz = z.infer<typeof LabeledPieDonutViz>;

export const LabeledTableViz = TableViz.omit({ columns: true }).extend({
  columns: z.array(LabeledTableColumnDef).min(1)
});
export type LabeledTableViz = z.infer<typeof LabeledTableViz>;

// ─── Discriminated Union ───

export const LabeledVizSpec = z.discriminatedUnion('vizType', [
  LabeledLineBarGraphViz,
  LabeledBarChartViz,
  LabeledLineChartViz,
  LabeledKpiCardViz,
  LabeledPieDonutViz,
  LabeledTableViz
]);
export type LabeledVizSpec = z.infer<typeof LabeledVizSpec>;

export { NoDataViz };
